<div class="loading-overlay" *ngIf="appLoader">
    <img src="assets/images/FullScreenLoaderFinal.gif" />
</div>